import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FullReturnsBreadcrumb } from './FullReturnsBreadcrumb';
import { SimpleReturnsBreadcrumb } from './SimpleReturnsBreadcrumb';
import { retailerSettingsService } from './../../services';

const mapStateToProps = ({
  page: { bypassSteps = [] },
}) => ({
  disabledStep2: bypassSteps.includes('methods'),
});

const Component = ({ currentStep, disabledStep2, navigateToStep }) => {
  const handleStepClick = (step, e) => {
    e.preventDefault();
    if (step && currentStep > step) {
      navigateToStep(step);
    }
  };
  return (
    <span className="returns-breadcrumb">
      {!retailerSettingsService.getIsSimpleReturnsBasic() ? (
        <FullReturnsBreadcrumb
          step={currentStep}
          disabledStep2={disabledStep2}
          handleStepClick={handleStepClick}
        />
      ) : (
        <SimpleReturnsBreadcrumb step={currentStep} handleStepClick={handleStepClick} />
      )}
    </span>
  );
};

Component.propTypes = {
  currentStep: PropTypes.number.isRequired,
  disabledStep2: PropTypes.bool.isRequired,
  navigateToStep: PropTypes.func.isRequired,
};

export const Breadcrumb = connect(mapStateToProps)(Component);
